<template>
    <slot v-bind="{ months, isMobile }" />
</template>

<script setup>
import { computed, onBeforeMount, ref } from 'vue';
import { groupBy, map } from 'lodash';

const props = defineProps({
    items: {
        type: Array,
        required: true,
    },
});

const isMobile = ref(null);

const months = computed(() => {
    let groupedByMonth = groupBy(props.items, item => {
        return item._auxiliary.groupByMonth;
    });

    groupedByMonth = map(groupedByMonth, (items, key) => {
        return {
            id: `month-${key}`,
            title: items[0]._auxiliary.groupNameMonth,
            date: key,
            instances: items,
        }
    });

    return groupedByMonth;
});

onBeforeMount(() => {
    const mediaQuery = window.matchMedia("(max-width: 62.5em)");

    isMobile.value = mediaQuery.matches;

    mediaQuery.addEventListener('change', event => {
        isMobile.value = event.matches;
    });
});
</script>
